var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"rows":3,"disabled":_vm.disabled,"type":"textarea","resize":"none"},on:{"input":_vm.valueChange},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }